export default "__VITE_ASSET__Crgx8mB9__"